export default "/images/68b61fdabdcd3d932534ab879e32418a.avif";